// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".eopoi-widget .eopoi-opening-times td{vertical-align:top}.eopoi-widget .eopoi-opening-times-weekday{font-weight:700;padding-right:2em}", ""]);
// Exports
module.exports = exports;
